
import { CLEAR_FILESTORE } from "./Contexts/UserContext/UserContext"
import { deepcopy, getLog } from "./helpers/helpers"

// import { prepopulated_cache } from "./resources/caches/prepopulated_cache.js"
import { get_store_WalletHistoryCache } from "./RunFileStore"

const idbKeyval = require("idb-keyval") // import idbKeyval from 'idb-keyval'


// -----------------------------------------------------------------------
//
//            Wallet_History_Cache (local file on disk)
//
//  It contains an object of object[txhash]->tx_object (which is like a hashmap)
//  because this acts like a hashmap we can search if a txhash exist in the cache in O(1)
//
//  It also contains a "last_seen_height" so that we can only recheck txs that have a height
//  equal or above to this variable
//
// -----------------------------------------------------------------------


// see https://github.com/sindresorhus/electron-store


/* TODO to optimize add a last_seen_height in the file on disk even if cache is empty so we can avoid rechecking
     blockchain for useless txs even if they are not to put in cache
        => au lieu de le mettre dans le wallet_history_cache plutot le mettre dans le 2e fichier,
            comme ça le wallet_history_cache reste dédié aux txs ?
*/


/**
 * usage:
 *      check if something is in the cache in O(1) using last_seen_height and isLocationInCache(location)
 */
export default class WalletHistoryCache {

    constructor(owneraddress, tokenorigin, devBrowserCacheIdb = null) {
        this.classname = "WalletHistoryCache: "
        const function_id = this.classname + "constructor(): "
        const log = getLog(function_id)

        log("owneraddress=", owneraddress, " tokenorigin=", tokenorigin)

        this.cache = {}
        this.last_seen_height = 0
        this.size = 0

        // contains array of : {location: X, height: Y, usertimestamp: Z}
        // will become useful when whatsonchain start paginating their history API
        // or if a wallet contains too much to load fast enough
        this.cache_ordered_location_history = []

        this.filekey = owneraddress + "_" + tokenorigin
        log("this.filekey = ", this.filekey)

        // load the store from file if we are in production & already have one
        try {
            // production => electron => saved on disk
            // beware adding tokenorigin in name will break keeping the entire history in case of a contract_backup => deal with that later if the case arises
            // this.filestore = get_store_WalletHistoryCache(owneraddress)
            this.filestore = get_store_WalletHistoryCache(this.filekey) // will return null if not in production (& will not raise an error)
            log("!!this.filestore=", !!this.filestore)
        }
        catch (error) {
            throw new Error(function_id + ".1 couldn't get_store_WalletHistoryCache() for " + owneraddress + " with error: " + error)
        }

        // in dev-mode, mock with indexed-db cache
        if (!this.filestore && devBrowserCacheIdb) {
            log("setting this.filestore to devBrowserCacheIdb")
            this.filestore = devBrowserCacheIdb
        }

        if (this.filestore) {
            try {
                if (CLEAR_FILESTORE) this.filestore.clear()

                const store = deepcopy(this.filestore.store)
                this.last_seen_height = store["last_seen_height"] || 0
                log("this.last_seen_height = ", this.last_seen_height)

                // now that it is stored in this.last_seen_height, we can delete store.last_seen_height
                // to make it easier to return only transactions + correctly calculate store size
                delete store["last_seen_height"]

                this.cache = store
                // log("this.cache=",this.cache) // will pollute logs

                this.size = Object.keys(this.cache).length
                log("this.size=" + this.size)
            }
            catch (error) {
                throw new Error(function_id + ".1.5: " + error + error.stack)
            }

            try {
                // populate & sort this.cache_ordered_location_history and this.last_seen_height

                var store_keys = Object.keys(this.cache)

                store_keys.forEach(key => {
                    var entry = this.cache[key]
                    // log("filestore entry = ",entry) // will pollute logs

                    this.cache_ordered_location_history.push({
                        location: entry.location,
                        height: entry.blockheight,
                        usertimestamp: entry.timestamp
                    })

                    if (entry.blockheight > this.last_seen_height) {
                        log("detected need to update last_seen_height to", entry.blockheight)
                        this.last_seen_height = entry.blockheight
                    }
                })

                this.cache_ordered_location_history.sort(function(a, b) {
                    return a.blockheight - b.blockheight  // TODO see if we should rather sort by blockheight or usertimestamp 
                })

                // sanity check
                if (this.cache_ordered_location_history.length > 2
                    && this.cache_ordered_location_history[0].blockheight > this.cache_ordered_location_history[1].blockheight) {
                    throw new Error(function_id
                        + " error in the ordering of this.cache_ordered_location_history:\n"
                        + this.cache_ordered_location_history
                    )
                }

                // log("sorted by blockheight (first should be lower blockheight)"
                //     +" cache_ordered_location_history: \n",this.cache_ordered_location_history)  // will pollute logs

                log("this.last_seen_height=", this.last_seen_height)

                if (this.last_seen_height) {
                    log("updating this.last_seen_height to", this.last_seen_height)
                    this.filestore.set("last_seen_height", this.last_seen_height)
                } else {

                    log("updating this.last_seen_height to 0")
                    this.filestore.set("last_seen_height", 0)
                }
            }
            catch (error) { throw new Error(function_id + ".2: " + error) }
        }
    }

    clearCache() {  // clear cache on disk and in memory
        this.cache = {}
        this.last_seen_height = 0
        this.size = 0
        this.cache_ordered_location_history = []
        if (this.filestore) this.filestore.clear()  // on disk
    }

    /**
     * @returns the cache as an array instead of as an object
     */
    get_cache_array() {
        const function_id = this.classname + "get_cache_array(): "
        const log = getLog(function_id)

        const allkeys = Object.keys(this.cache)
        log("this.size = " + this.size)
        var cache_array = []
        for (let i = 0; i < allkeys.length; i++) {
            cache_array.push(this.cache[allkeys[i]])
        }
        return cache_array
    }

    /**
     * @param {string} location containing _oX
     * @returns true or false
     */
    isLocationInCache(location) {

        if (!location.includes("_")) {
            throw new Error("isLocationInCache: invalid location " + location)
        }

        // TODO CHECK IF NORMAL TO HAVE TO DO [location]
        // if (this.cache.hasOwnProperty([location])) return true  // check in O(1)

        const allkeys = Object.keys(this.cache)
        if (allkeys.includes([location])) return true
        if (allkeys.includes(location)) return true

        return false
    }

    /**
     * @param {string} txhash 
     * @returns true if at least 1 entry has this txhash in its location
     */
    isTXhashInCache(txhash) {
        // TODO optimize in O(1) with Object.keys(this.cache) ??
        txhash = txhash.split('_')[0]  // safety check
        var cache_array = this.get_cache_array()
        for (let i = 0; i < cache_array.length; i++) {
            var entry = cache_array[i]
            if (entry.location.split('_')[0] === txhash) return true
        }
        return false
    }


    /**
     * 
     * @param {string} txhash 
     * @returns all the _o1, _o2, _o3, etc
     */
    get_txids_from_txhash(txhash) {
        txhash = txhash.split('_')[0]  // safety check
        var all_txids = Object.keys(this.cache).filter(txid => txid.includes(txhash))
        return all_txids
    }

    update_last_seen_height(new_height) {
        const function_id = this.classname + " update_last_seen_height(): "
        const log = getLog(function_id)
        log("new_height=", new_height)

        if (new_height && new_height > this.last_seen_height) {
            this.last_seen_height = new_height
            if (this.filestore) this.filestore.set("last_seen_height", new_height)
        }
    }

    /** format of each entry:
        {
            date:   			str_txdate,
            action: 			action,
            timestamp: 			final_timestamp,
            location: 			jig_location, 
            blockheight:        tx_blockheight,
        }
    */
    add_entries(array_new_entries) {
        const function_id = this.classname + " add_entries(): "
        const log = getLog(function_id)

        try {
            log(" this.size = " + this.size)

            if (typeof array_new_entries !== 'object') {
                throw new Error(function_id + 'array_new_entries should be object : ' + array_new_entries)
                // throw gives better error trace than expect()
            }

            // if we sent 1 object instead of an array let's convert it to an array
            if (!Array.isArray(array_new_entries)) array_new_entries = [array_new_entries]

            let valid_format = array_new_entries.every(function(e) {
                // this is way faster than "in" or "hasownproperty", cf https://stackoverflow.com/a/22074727
                return (
                    !!e.date
                    && !!e.action
                    && !!e.timestamp
                    && !!e.location
                    && !!e.blockheight
                )
            })
            if (!valid_format) throw new Error(function_id + 'wrong format missing properties: ' + array_new_entries)

            // very important to start by ordering the new_entries by blockheight, in case the loop aborts midway!
            array_new_entries.sort(function(a, b) {
                return a.blockheight - b.blockheight;
            });

            for (let i = 0; i < array_new_entries.length; i++) {
                var curr_new_entry = array_new_entries[i]
                log("add entry: ", curr_new_entry)
                if (typeof curr_new_entry !== 'object') {
                    throw new Error(function_id + 'curr_new_entry should be object : ' + curr_new_entry)
                    // throw gives better error trace than expect()
                }
                if (!curr_new_entry.blockheight || curr_new_entry.blockheight <= 0) { // we should not try to add to cache unconfirmed transactions because blockheight is still unknown
                    throw new Error(function_id + " problem with curr_new_entry.blockheight, "
                        + "are you trying to add unconfirmed tx to cache ? : "
                        + curr_new_entry.blockheight + " for location: " + curr_new_entry.location)
                }
                if (!Number.isInteger(curr_new_entry.blockheight))
                    throw new Error(function_id
                        + 'curr_new_entry.blockheight must be an integer : '
                        + curr_new_entry.blockheight
                    )

                let pre_existing_entry = this.cache[curr_new_entry.location]
                let bool_exists = !!pre_existing_entry

                if (bool_exists) {
                    console.error(function_id + " this location is already in cache, aborting : "
                        + curr_new_entry.location) //+" \n all keys : "+JSON.strigify(Object.keys(this.cache)))
                }
                else {
                    // all checks passed

                    // add to object that acts as an hashtable
                    this.cache[curr_new_entry.location] = curr_new_entry
                    // add to the cached ordered tx hash history
                    this.cache_ordered_location_history.push({
                        location: curr_new_entry.location,
                        height: curr_new_entry.blockheight,
                        usertimestamp: curr_new_entry.timestamp
                    })
                    // add to filestore if we have one
                    if (this.filestore) this.filestore.set(curr_new_entry.location, curr_new_entry)
                    //
                    // TODO maybe we should re-order the cache_ordered_location_history after the for loop ?
                    //
                    this.size++
                    // update last_seen_height
                    if (curr_new_entry.blockheight > this.last_seen_height) {
                        this.last_seen_height = curr_new_entry.blockheight
                    }
                }
            }
        } catch (error) {
            throw new Error(function_id + error)
        }
    }
}


// for dev/web mode, this is a mocking of the filestore cache:
// A basic cache implementation that stores data in the indexedDB as key-values
/**
 *  named IDBs: 
    const customStore = createStore('custom-db-name', 'custom-store-name');
    important:  createStore() won't let you create multiple stores within the same database.
                Nor will it let you create a store within an existing database.
 */
export class DevBrowserCacheIdb {
    constructor(owneraddress, tokenorigin) {
        const function_id = "DevBrowserCacheIdb: "
        const log = getLog(function_id)
        this.log = log

        this.db_name = owneraddress + "_" + tokenorigin // forced to inject both here since we can't have multiple stores in same db
        this.store_name = "keyval" // default

        log("idbKeyval.createStore(): ", this.db_name, this.store_name)
        this.customStore = idbKeyval.createStore(this.db_name, this.store_name)
        // log("this.customStore=",this.customStore)
    }

    async entriesAsObject() {
        const log = this.log

        log("entriesAsObject(): start")
        const entries_array = await idbKeyval.entries(this.customStore)
        log("entriesAsObject(): length=", entries_array.length)

        const entries_obj = {}
        for (let i = 0; i < entries_array.length; i++) {
            var entry = entries_array[i]
            entries_obj[entry[0]] = entry[1]
        }
        return entries_obj
    }

    async init() {
        const log = this.log

        log("init()")

        this.store = await this.entriesAsObject()
        log("this.store = ", this.store)
        this.size = Object.keys(this.store).length
        log("this.size = ", this.size)
    }

    async set(key, value) {
        var val = await idbKeyval.get(key, this.customStore)
        if (!val) {
            this.size += 1
        }
        idbKeyval.set(key, value, this.customStore)
        this.store = await idbKeyval.entries(this.customStore)
    }

    async clear() {
        await idbKeyval.clear(this.customStore)
        this.size = 0
        this.store = {}
    }
}
